/**
 * @file Fetch emojis
 */
import { EmojiVersion } from '../enums'
import { EmojiCategory } from '../types'

/**
 * Composes a URL to an emoji.
 * @param code A code that can be found in the emoji manifest.
 */
function emojiPngUrl(code: string, version: EmojiVersion = EmojiVersion.legacy): string {
  if (version == EmojiVersion.legacy) {
    return `https://padlet.net/icons/png/${code}.png`
  } else {
    return `https://padlet.net/icons/${version}/png/${code}.png`
  }
}

/**
 * Composes a URL to an SVG emoji.
 * @param code A code that can be found in the emoji manifest.
 */
function emojiSvgUrl(code: string, version: EmojiVersion = EmojiVersion.legacy): string {
  if (version == EmojiVersion.legacy) {
    return `https://padlet.net/icons/svg/${code}.svg`
  } else {
    return `https://padlet.net/icons/${version}/svg/${code}.svg`
  }
}

/**
 * Parses a list of categories of emojis.
 */
function parseEmojiCategories(categories: string[]): EmojiCategory[] {
  return categories.map(
    (c): EmojiCategory => ({
      label: c,
    }),
  )
}

export { parseEmojiCategories, emojiPngUrl, emojiSvgUrl }
